import React from 'react';
import { LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-accent text-secondary pt-20 pb-10" data-id="element-180">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-181">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12 mb-16" data-id="element-182">
          <div className="col-span-2 lg:col-span-2" data-id="element-183">
            <a href="/" className="text-2xl font-serif font-medium tracking-wide text-secondary mb-6 block" data-id="element-184">
              henkel<span className="text-primary" data-id="element-185">·</span>energie
            </a>
            <p className="text-secondary/60 font-light max-w-sm mb-8" data-id="element-186">
              Architektur trifft Energieberatung. Nachhaltige und individuelle
              Konzepte für Bestandsgebäude.
            </p>
          </div>

          <div data-id="element-187">
            <h4 className="font-medium mb-6 uppercase tracking-wider text-sm text-secondary/80" data-id="element-188">
              Navigation
            </h4>
            <ul className="space-y-4 text-secondary/60 font-light" data-id="element-189">
              <li data-id="element-190">
                <a href="/#leistungen" className="hover:text-primary transition-colors" data-id="element-191">
                  Leistungen
                </a>
              </li>
              <li data-id="element-192">
                <a href="/#ueber-mich" className="hover:text-primary transition-colors" data-id="element-193">
                  Über mich
                </a>
              </li>
              <li data-id="element-194">
                <a href="/#foerderungen" className="hover:text-primary transition-colors" data-id="element-195">
                  Förderungen
                </a>
              </li>
              <li data-id="element-196">
                <a href="/#kontakt" className="hover:text-primary transition-colors" data-id="element-197">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-198">
            <h4 className="font-medium mb-6 uppercase tracking-wider text-sm text-secondary/80" data-id="element-199">
              Rechtliches
            </h4>
            <ul className="space-y-4 text-secondary/60 font-light" data-id="element-200">
              <li data-id="element-201">
                <a href="?page=impressum" className="hover:text-primary transition-colors" data-id="element-202">
                  Impressum
                </a>
              </li>
              <li data-id="element-203">
                <a href="?page=datenschutz" className="hover:text-primary transition-colors" data-id="element-204">
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-secondary/40 font-light" data-id="element-205">
          <p data-id="element-206">
            © {new Date().getFullYear()} Josephine Henkel. Alle Rechte
            vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}